import SortingVisualizer from "./SortingVisualizer";

export default SortingVisualizer;
